import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import Image from './../Image'
import Batch from './../Batch'

import styles from './styles.module.scss'

const Teaser = (props) => {
	
	const {
		blok: {
			headline,
			images,
			max_height,
			home_banner
		}
	} = props

	const teaserClasses = cx({
		[styles['teaser']]: true,
		[styles['teaser--bottom']]: home_banner,
	})

	const imageWrapperClasses = cx({
		[styles['teaser__image-wrapper']]: true,
		[styles['teaser__image-wrapper--large']]: max_height == 95,
		[styles['teaser__image-wrapper--small']]: max_height == 60
	})

	return (
		<SbEditable content={props.blok}>
			<section className={teaserClasses} style={{ maxHeight: `${max_height}rem` }}>
				{images.length && (
					<div className={styles['teaser__images']}>
						{images.map((image, i) => {
							if (image.asset.filename.includes('mp4')) {
								return (
									<figure key={i} className={imageWrapperClasses}>
										<video
											autoPlay
											playsInline
											muted
											loop
											src={image.asset.filename}
											className={styles['teaser__video']}
										/>
									</figure>
								)
							} else {
								return (
									<figure key={i} className={imageWrapperClasses}>
										<Image className={styles['teaser__image']} image={image.asset} blok={image} params={{ maxWidth: images.length == 2 ? 500 : 1000 }} />
									</figure>
								)
							}
						})}
					</div>
				)}
				{headline && (
					<div className={`container ${styles['teaser__container']}`}>
						<h1 className={`heading-1 ${styles['teaser__heading']}`}><b>{headline}</b></h1>
					</div>
				)}
				{props.blok.batch && <Batch blok={props.blok.batch} />}
			</section>
		</SbEditable>
	)
}

export default Teaser
